import { getAllWeatherFromDB, getWeatherFromDB} from '../../../api/eastCoastMonitorApi/weatherApi'
import Utils from '../../../utils/utils'

const state = {
  allWeather: [],
  weather:{}
}

const getters = {
  getAllWeather: state => {
    return state.allWeather
  },

  getWeather: state => {
    return state.weather
  }
}

const actions = {
  async getAllWeather({ commit }) {
    commit('allWeather', await getAllWeatherFromDB())
  },

  async getWeather({commit}, condition = {}) {
    commit('weather', await getWeatherFromDB(condition))
  }
}

const mutations = {
  allWeather: (state, data) => {
    if(!Utils.isEmptyObject(data)) {
      state.allWeather = data
    }
  },

  weather: (state, data) => {
    if(!Utils.isEmptyObject(data)) {
      state.weather = data
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}